import { useAppDispatch } from "hooks/hooks";
import { setSort } from "../main.slice";
import InfoTooltip from "components/Popup/InfoTooltip";
import { HiMiniDevicePhoneMobile } from "react-icons/hi2";
import { TiThMenu } from "react-icons/ti";
import { AiFillStar } from "react-icons/ai";

const TableHeader = () => {
  const dispatch = useAppDispatch();
  const handleSort = (
    sortKey: string, typeOfValue: 'string' | 'boolean' | 'date'
  ) => {
    dispatch(setSort({ key: sortKey, typeOfValue: typeOfValue }));
  };

  return (
    <div className="g-grid g-header">
      <div className="row">
        <div className="col lowercase center separator-line clickable"
          onClick={() => handleSort("isFavourite", "boolean")}>
          <AiFillStar size={18} />
        </div>
        <div className="col lowercase center separator-line">
          <span>novi</span>
        </div>
        <div className="col lowercase center clickable"
          onClick={() => handleSort("building.fullName", "string")}>
          <span>naziv projekta</span>
        </div>
        <div className="col separator-line"></div>
        <div className="col lowercase center separator-line">
          <span>opis nekretnine</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>status</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>fakturisali</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>naplatili</span>
        </div>
        <div className="col lowercase center">
          <span>ostalo</span>
        </div>
        <div className="col separator-line"></div>
        <div></div>
        <div className="col lowercase center separator-line clickable"
          onClick={() => handleSort("building.contractDate", "date")}>
          <span>datum ugovora</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>početak radova</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>krajnji rok</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>dana ostalo</span>
        </div>
        <div className="col lowercase center separator-line">
          <span>završio</span>
        </div>
        <InfoTooltip
          tooltip="za mobilnu app"
          classesProp="col lowercase center separator-line">
          <HiMiniDevicePhoneMobile size={13} />
        </InfoTooltip>
        <InfoTooltip
          tooltip="sakrij u menijima"
          classesProp="col lowercase center separator-line">
          <TiThMenu size={13} />
        </InfoTooltip>
        <div className="col lowercase center separator-line">
          <span>manager</span>
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
